import React from 'react';
import { setTitle } from "../../../helpers/MetaTag";
import ProfileView from "../../../components/sections/front/User/ProfileView";
import ChangePassword from "../../../components/sections/front/User/ChangePassword";
import DeleteAccount from "../../../components/sections/front/User/DeleteAccount";
import CurrentAddress from "../../../components/sections/front/User/CurrentAddress";
import ProfileStatistics from "../../../components/sections/front/User/ProfileStatistics";
import CurrentSubscription from "../../../components/sections/front/User/CurrentSubscription";

const Profile = () => {
  setTitle("Memory Doddle | Profile");

  return (
    <>
      <div className="relative space-y-5">
        <div className="grid grid-cols-3 gap-4 3xl:gap-6 items-start">
          <div className="relative col-span-2 grid grid-cols-1 gap-4">
            <ProfileView />
            <ChangePassword />
            <DeleteAccount />
          </div>
          <div className="relative grid grid-cols-1 gap-4">
            <ProfileStatistics />
            <CurrentSubscription />
            <CurrentAddress />
          </div>
        </div>
      </div>
    </>
  );
};

export default Profile;